import { ElementType } from 'react';

function isAggregator(type: ElementType | string): boolean {
  if (typeof type === 'string') {
    return false;
  }
  // @ts-ignore
  const { propTypes } = type;
  return propTypes ? 'data' in propTypes : false;
}

export default isAggregator;
